import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MapImg from "../../../assets/user/images/Google_Maps_icon.svg";
import { api } from "../../../utlis/user/api.utlis";
import Loader from "../../../layouts/loader/Loader";
import ApiService from "../../../core/services/ApiService";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import { routes } from "../../../utlis/user/routes.utlis";
import { GeolocationApiKey } from "../../../utlis/common.utlis";
import InputMask from "react-input-mask";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

const JobPost = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  const [jobId, setJobId] = useState(null);
  const [allFormvalues, setFormValues] = useState();
  const [planType, setPlanType] = useState("50");
  const [loading, setLoading] = useState(false);
  const [startTime, setStartTime] = useState("09:00");
  const [startTimeErr, setStartTimeErr] = useState(false);
  const [endTime, setEndTime] = useState("21:00");
  const [endTimeErr, setEndTimeErr] = useState(false);
  const [jobType, setJobType] = useState("");
  const [jobTypeErr, setJobTypeErr] = useState(false);
  const [locError, setLocError] = useState(false);
  const { address, lat, lng, state } = useParams();
  const [location, setLocation] = useState({
    lat: lat ?? null,
    lng: lng ?? null,
    address: address ?? null,
    state: state ?? null,
  });
  let userData = JSON.parse(localStorage.getItem("careexchange"));
  const [categories, setCategory] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  const [jobRequestCount, setJobRequestCount] = useState(0);
  const [list, setList] = useState([]);
  const [coupon, setCoupon] = useState();
  const [openCouponModal, setCouponModal] = useState(false);

  const initialValuesCoupon = {
    coupon: coupon?.currentAppliedCoupon?.coupon_code ?? "",
  };

  const validationSchemaCoupon = Yup.object().shape({
    coupon: Yup.string().required("Please select a coupon"),
  });

  const postCouponApply = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setCoupon(response.data.data);
      setPlanType(response?.data?.data?.postPriceForOneMonth ?? "50");
    } else {
      setCoupon();
    }
  };

  const getCouponList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setList(response.data.data.coupons);
    } else setList([]);
    setLoading(false);
  };

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("category list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const getSubCategoryList = async (id) => {
    const response = await ApiService.getAPIWithAccessToken(
      api.categoryList + `?categoryid=${id}`
    );
    // console.log("sub category list => ", response.data);
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setSubCategory(response?.data?.data?.categories);
    } else setSubCategory([]);
  };

  const getJobRequestCount = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("job request count => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setJobRequestCount(response.data.data.jobRequestCount);
    } else setJobRequestCount(0);
    setLoading(false);
  };

  const initialValues = {
    title: "",
    description: "",
    qualification: "",
    benefit: "",
    address: "",
    pay_range_min: "",
    pay_range_max: "",
    start_time: "",
    end_time: "",
    pay_range_type: "",
    name: userData.fullname ?? "",
    email: userData.email ?? "",
    phone: userData.mobile ?? "",
    experience: "",
    shift: "",
    category: "",
    sub_category: "",
  };

  const initialPaymentValues = {
    amount: coupon?.postPriceForOneMonth ?? "50",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Job title is required!"),
    description: Yup.string().required("Job description is required!"),
    qualification: Yup.string(),
    benefit: Yup.string(),
    pay_range_min: Yup.string().required("Minimum salary is required!"),
    pay_range_max: Yup.string().required("Maximum salary is required!"),
    pay_range_type: Yup.string().required("Payment type is required!"),
    address: Yup.string().required("Address is required!"),
    name: Yup.string().required("Name is required!"),
    email: Yup.string().required("Email is required!"),
    phone: Yup.string()
      .min(14, "Phone is invalid")
      .required("Phone is required!"),
    experience: Yup.string(),
    shift: Yup.string(),
    category: Yup.string().required("Category is required!"),
    sub_category: Yup.string().required("Sub Category is required!"),
    start_time: Yup.string().required("Start Time is required!"),
    end_time: Yup.string().required("End Time is required!"),
  });

  const addPost = async (formValue) => {
    setLoading(true);
    if (coupon?.postLimitExpired === false) {
      let form = JSON.stringify({
        care_provider_id: null,
        title: formValue.title,
        description: formValue.description,
        address: location.address,
        state: location.state,
        latitude: location.lat,
        longitude: location.lng,
        service_type: formValue.sub_category,
        qulification_required: formValue.qualification ?? null,
        min_salary: formValue.pay_range_min,
        max_salary: formValue.pay_range_max,
        pay_range_type: formValue.pay_range_type,
        employee_benifits: formValue.benefit ?? null,
        contact_person_name: formValue.name,
        contact_person_email: formValue.email,
        contact_person_phone: formValue.phone,
        shift: formValue.shift ?? null,
        working_expirence: formValue.experience ?? null,
        working_time: `${formValue.start_time} - ${formValue.end_time}`,
      });
      const response = await ApiService.postAPIWithAccessToken(
        api.addPost,
        form
      );
      setLocation({
        lat: null,
        lng: null,
        address: null,
        state: null,
      });
      setStartTime("09:00");
      setEndTime("21:00");
      setJobType("");
      if (response.data.status) {
        toast.success(response.data.message);
        navigate(routes.postedJob);
      } else {
        toast.error(response.data.message);
      }
    } else {
      setFormValues(formValue);
      setTab(2);
    }
    setLoading(false);
  };

  const makePayment = async (formValue) => {
    setLoading(true);
    let formData = {
      care_provider_id: null,
      title: allFormvalues.title,
      description: allFormvalues.description,
      address: location.address,
      state: location.state,
      latitude: location.lat,
      longitude: location.lng,
      service_type: allFormvalues.sub_category,
      qulification_required: allFormvalues.qualification ?? null,
      min_salary: allFormvalues.pay_range_min,
      max_salary: allFormvalues.pay_range_max,
      pay_range_type: allFormvalues.pay_range_type,
      employee_benifits: allFormvalues.benefit ?? null,
      contact_person_name: allFormvalues.name,
      contact_person_email: allFormvalues.email,
      contact_person_phone: allFormvalues.phone,
      shift: allFormvalues.shift ?? null,
      working_expirence: allFormvalues.experience ?? null,
      working_time: `${allFormvalues.start_time} - ${allFormvalues.end_time}`,
    };
    if (coupon?.postLimitExpired === true) {
      formData.duration =
        formValue.amount === coupon?.postPriceForOneMonth ? 30 : 90;
    }
    let form = JSON.stringify(formData);
    const response = await ApiService.postAPIWithAccessToken(api.addPost, form);
    setLocation({
      lat: null,
      lng: null,
      address: null,
      state: null,
    });
    setStartTime("09:00");
    setEndTime("21:00");
    setJobType("");
    if (response.data.status) {
      if (coupon?.postLimitExpired === true) {
        let formPayment = JSON.stringify({
          postId: response.data.data.id,
          amount: formValue.amount,
          plan_type:
            formValue.amount === "" ||
            formValue.amount === null ||
            formValue === undefined
              ? ""
              : formValue.amount === coupon?.postPriceForOneMonth
              ? "Monthly"
              : "Quarterly",
          duration: formValue.amount === coupon?.postPriceForOneMonth ? 30 : 90,
        });
        const responsePayment = await ApiService.postAPIWithAccessToken(
          api.addPostPayment,
          formPayment
        );
        if (responsePayment.data.status) {
          toast.success(responsePayment.data.message);
          window.location.href = responsePayment.data.data.approvalUrl;
        } else {
          toast.error(responsePayment.data.message);
        }
      } else {
        toast.success(response.data.message);
        navigate(routes.postedJob);
      }
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GeolocationApiKey,
    libraries: ["places"],
  });

  function findStateCity(type, arr) {
    for (let i in arr) {
      if (arr[i].types.includes(type)) {
        return arr[i].long_name;
      }
    }
    return null;
  }

  const handlePlaceChange = (setFieldValue) => {
    let [address] = inputRef.current.getPlaces();
    setLocation({
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      address: address.formatted_address,
      state: findStateCity(
        "administrative_area_level_1",
        address.address_components
      ),
    });
    setFieldValue("address", address.formatted_address);
  };

  const applyCoupon = async (formValue) => {
    if (formValue === "" || formValue === null || formValue === undefined) {
      toast.error("Please enter a coupon code.");
      return;
    }
    setLoading(true);
    const responseApply = await ApiService.getAPIWithAccessToken(
      api.postCouponApply + `?couponCode=${formValue}`
    );
    if (responseApply.data.status && responseApply.data.statusCode === 200) {
      setCoupon(responseApply.data.data);
      postCouponApply(api.postCouponApply);
      toast.success(responseApply.data.message);
      setCouponModal(false);
    } else {
      setCoupon(responseApply.data.data);
      postCouponApply(api.postCouponApply);
      toast.error(responseApply.data.message);
    }
    setLoading(false);
  };

  const cancelCoupon = async (couponCode) => {
    setLoading(true);
    let form = JSON.stringify({
      couponCode: couponCode ?? "",
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.cancelCoupon,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      postCouponApply(api.postCouponApply);
      toast.success(response.data.message);
      setCouponModal(false);
    } else {
      postCouponApply(api.postCouponApply);
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategoryList(api.categoryList);
    getJobRequestCount(api.jobRequestCount);
    postCouponApply(api.postCouponApply);
    getCouponList(api.leadCouponList + `?type=job`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      {tab === 1 ? (
        <div className="container">
          <div className="messages-tab">
            <ul className="nav nav-tabs">
              <li>
                <Link className="btn-wh" to={routes.careNetwork}>
                  Find A Job
                </Link>
              </li>
              <li>
                <Link className="btn-wh active" to={routes.addPost}>
                  Post A Job
                </Link>
              </li>
              <li>
                <Link to={routes.appliedJob} className="btn-wh">
                  {" "}
                  Applied Jobs
                </Link>
              </li>
              <li>
                <Link to={routes.postedJob} className="btn-wh">
                  Posted Job
                </Link>
              </li>
              <li className="position-relative">
                <Link to={routes.jobRequest} className="btn-bl">
                  Job Requests
                </Link>
                {jobRequestCount != 0 &&
                jobRequestCount != undefined &&
                jobRequestCount != null ? (
                  <span className="bg-danger dots"></span>
                ) : null}
              </li>
            </ul>
          </div>
          <div className="carenetwork-section mt-4 pt-3">
            <div className="care-title-header">
              <h2 className="heading-title">Post New Job</h2>
            </div>
            <div className="post-newjob-content">
              <div className="post-job-form">
                <Formik
                  initialValues={initialValues}
                  validateOnChange={true}
                  validationSchema={validationSchema}
                  onSubmit={addPost}
                  enableReinitialize
                >
                  {({ values, setFieldValue }) => (
                    <Form id="add-post-form">
                      <div className="post-job-card">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Job Title</h4>
                              <Field
                                type="text"
                                className="form-control"
                                name="title"
                                placeholder="Enter Job Title"
                              />
                              <ErrorMessage
                                name="title"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group search-form-group mb-1">
                              <h4>Job Location</h4>
                              {isLoaded && (
                                <StandaloneSearchBox
                                  onLoad={(ref) => (inputRef.current = ref)}
                                  onPlacesChanged={() =>
                                    handlePlaceChange(setFieldValue)
                                  }
                                >
                                  <input
                                    className="form-control"
                                    placeholder="Enter Job Location"
                                    defaultValue={location.address}
                                  />
                                </StandaloneSearchBox>
                              )}
                              <span className="form-group-icon">
                                <img src={MapImg} />
                              </span>
                            </div>
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <h4>Job Description</h4>
                              <Field
                                type="text"
                                as="textarea"
                                className="form-control"
                                name="description"
                                placeholder="Enter Job Description"
                              />
                              <ErrorMessage
                                name="description"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="post-job-card">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Category</h4>
                              <Field name="category">
                                {({ field }) => (
                                  <select
                                    {...field}
                                    className="form-control"
                                    onChange={(e) => {
                                      setFieldValue(field.name, e.target.value);
                                      getSubCategoryList(e.target.value);
                                    }}
                                  >
                                    <option value="">Select Category</option>
                                    {categories.length !== 0
                                      ? categories.map((ele, indx) => {
                                          return (
                                            <option key={indx} value={ele.id}>
                                              {ele.name ?? "NA"}
                                            </option>
                                          );
                                        })
                                      : null}
                                  </select>
                                )}
                              </Field>
                              <ErrorMessage
                                name="category"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Sub Category</h4>
                              <Field
                                as="select"
                                type="text"
                                className="form-control todo-list-input"
                                name="sub_category"
                              >
                                <option value="">Select Sub Category</option>
                                {subCategories.length !== 0
                                  ? subCategories.map((ele, indx) => {
                                      return (
                                        <option key={indx} value={ele.id}>
                                          {ele.name ?? "NA"}
                                        </option>
                                      );
                                    })
                                  : null}
                              </Field>
                              <ErrorMessage
                                name="sub_category"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Qualifications Required</h4>
                              <Field
                                type="text"
                                className="form-control"
                                name="qualification"
                                placeholder="Enter Job Qualification Required"
                              />
                              <ErrorMessage
                                name="qualification"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>
                                Experience{" "}
                                <span
                                  className="text-danger"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  (In Years)
                                </span>
                              </h4>
                              <Field
                                type="number"
                                className="form-control"
                                name="experience"
                                placeholder="Enter Experience"
                              />
                              <ErrorMessage
                                name="experience"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Job Type</h4>
                              <Field
                                as="select"
                                type="text"
                                className="form-control todo-list-input"
                                name="shift"
                              >
                                <option value="">Select Job Type</option>
                                <option value="Full Time">Full Time</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Per Diem">Per Diem</option>
                              </Field>
                              <ErrorMessage
                                name="shift"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group">
                              <h4>Start Time</h4>
                              <Field name="start_time" className="form-control">
                                {({ field }) => (
                                  <DatePicker
                                    {...field}
                                    disableDayPicker
                                    format="hh:mm A"
                                    placeholder="Select Start Time"
                                    value={values.start_time || ""}
                                    onChange={(value) =>
                                      setFieldValue("start_time", value)
                                    }
                                    plugins={[
                                      <TimePicker
                                        hideSeconds
                                        position="bottom"
                                      />,
                                    ]}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="start_time"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <h4>End Time</h4>
                              <Field name="end_time" className="form-control">
                                {({ field }) => (
                                  <DatePicker
                                    {...field}
                                    disableDayPicker
                                    format="hh:mm A"
                                    placeholder="Select End Time"
                                    value={values.end_time || ""}
                                    onChange={(value) =>
                                      setFieldValue("end_time", value)
                                    }
                                    plugins={[
                                      <TimePicker
                                        hideSeconds
                                        minTime={values.start_time || "15:00"}
                                        position="bottom"
                                      />,
                                    ]}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="end_time"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <h4>Employment Benefits Offered</h4>
                              <Field
                                type="text"
                                as="textarea"
                                className="form-control"
                                name="benefit"
                                placeholder="Employment Benefits Offered"
                              />
                              <ErrorMessage
                                name="benefit"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="post-job-card">
                        <h3>Payment</h3>
                        <div className="row findcare-form">
                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Type</h4>
                              <div className="choosemiles-list">
                                <ul>
                                  <li>
                                    <div className="ceradio">
                                      <Field
                                        type="radio"
                                        name="pay_range_type"
                                        id="Hour"
                                        value="hour"
                                      />
                                      <label htmlFor="Hour">
                                        <span className="checkbox-text">
                                          {" "}
                                          Hourly
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="ceradio">
                                      <Field
                                        type="radio"
                                        name="pay_range_type"
                                        id="Daily"
                                        value="day"
                                      />
                                      <label htmlFor="Daily">
                                        <span className="checkbox-text">
                                          {" "}
                                          Daily
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="ceradio">
                                      <Field
                                        type="radio"
                                        name="pay_range_type"
                                        id="Week"
                                        value="week"
                                      />
                                      <label htmlFor="Week">
                                        <span className="checkbox-text">
                                          {" "}
                                          Weekly
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="ceradio">
                                      <Field
                                        type="radio"
                                        name="pay_range_type"
                                        id="Monthly"
                                        value="month"
                                      />
                                      <label htmlFor="Monthly">
                                        <span className="checkbox-text">
                                          {" "}
                                          Monthly
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="ceradio">
                                      <Field
                                        type="radio"
                                        name="pay_range_type"
                                        id="Year"
                                        value="year"
                                      />
                                      <label htmlFor="Year">
                                        <span className="checkbox-text">
                                          {" "}
                                          Yearly
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                </ul>
                                <ErrorMessage
                                  name="pay_range_type"
                                  component="div"
                                  className="alert alert-danger"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <h4>Proposed Salary Range</h4>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group search-form-group-r PerHour-form-group">
                                    <Field
                                      type="number"
                                      className="form-control"
                                      name="pay_range_min"
                                      placeholder="Enter Minimum Salary"
                                    />
                                    <span className="dollar-text">$</span>
                                  </div>
                                  <ErrorMessage
                                    name="pay_range_min"
                                    component="div"
                                    className="alert alert-danger"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group search-form-group-r PerHour-form-group">
                                    <Field
                                      type="number"
                                      className="form-control"
                                      name="pay_range_max"
                                      placeholder="Enter Maximum Salary"
                                    />
                                    <span className="dollar-text">$</span>
                                  </div>
                                  <ErrorMessage
                                    name="pay_range_max"
                                    component="div"
                                    className="alert alert-danger"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="post-job-card">
                        <h3>Contact Person For This Job Posting</h3>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <h4>Full Name</h4>
                              <Field
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Enter Full Name"
                              />
                              <ErrorMessage
                                name="name"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <h4>Email Id</h4>
                              <Field
                                type="text"
                                className="form-control"
                                name="email"
                                placeholder="Enter Email Id"
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <h4>Phone</h4>
                              <Field name="phone">
                                {({ field }) => (
                                  <InputMask
                                    {...field}
                                    mask="(999) 999-9999"
                                    className="form-control"
                                    maskChar=""
                                    onChange={(e) => {
                                      setFieldValue(field.name, e.target.value);
                                    }}
                                    placeholder="Enter phone"
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="phone"
                                component="div"
                                className="alert alert-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="post-job-card">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group d-flex justify-content-end">
                              <button
                                type="button"
                                className="btn-bl mx-2"
                                onClick={() => {
                                  setLocation({
                                    lat: null,
                                    lng: null,
                                    address: null,
                                    state: null,
                                  });
                                  setStartTime("09:00");
                                  setEndTime("21:00");
                                  setJobType("");
                                  document
                                    .getElementById("add-post-form")
                                    .reset();
                                }}
                              >
                                Clear All
                              </button>
                              <button className="btn-gr" type="submit">
                                Next
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {tab === 2 ? (
        <div className="payment-page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mb-2">
                {coupon?.postLimitExpired === false ? (
                  <div className="subscription-card-1 d-flex justify-content-between flex-column">
                    <div className="d-flex justify-content-between w-100 align-items-center">
                      <div className="subscription-info-1">
                        <div className="planname-text-1">
                          Job Opportunity Posting
                        </div>
                        <p>
                          Post your job openings and solicit for qualified
                          candidates
                        </p>
                      </div>
                      <div>
                        <Link
                          to=""
                          onClick={() => {
                            makePayment({
                              amount: "",
                            });
                          }}
                          className="btn-bl w-100"
                        >
                          Post Job
                        </Link>
                      </div>
                    </div>
                    <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                      {coupon?.leadUnlockedLimitExpired === true &&
                      coupon?.isCouponApplied === false &&
                      list?.length !== 0 ? (
                        <div className="text-center mb-2">
                          <span
                            style={{
                              color: "var(--blue)",
                              cursor: "pointer",
                            }}
                            className="text-decoration-underline"
                            onClick={() => setCouponModal(true)}
                          >
                            Have a Coupon Code?
                          </span>
                        </div>
                      ) : null}
                      {coupon?.isCouponApplied === true ? (
                        <div className="w-100">
                          <div class="promo-container mx-auto">
                            <div class="promo-box">
                              <div class="promo-left">
                                <span class="promo-icon">✔️</span>
                                <div>
                                  <p class="promo-code">
                                    Coupon Code:{" "}
                                    <strong>
                                      {coupon?.currentAppliedCoupon
                                        ?.coupon_code ?? ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  cancelCoupon(
                                    coupon?.currentAppliedCoupon?.coupon_code ??
                                      ""
                                  );
                                }}
                                class="promo-remove"
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {openCouponModal && (
                        <div className="text-center w-100 d-flex justify-content-center align-items-center">
                          <div className="nwi-input-wrapper">
                            <input
                              type="text"
                              name="text"
                              className="nwi-input"
                              placeholder="Enter Coupon Code"
                              autoComplete="off"
                            />
                            <button
                              onClick={() => {
                                applyCoupon(
                                  document.querySelector(".nwi-input").value
                                );
                              }}
                              className="nwi-Subscribe-btn"
                            >
                              Apply
                            </button>
                          </div>
                          <div className="mx-2">
                            <i
                              onClick={() => {
                                setCouponModal(false);
                              }}
                              style={{ fontSize: "20px", cursor: "pointer" }}
                              className="fa fa-close"
                            ></i>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="subscription-card-1 d-flex flex-column">
                    <div className="d-flex justify-content-between w-100 align-items-center">
                      <div className="subscription-info-1">
                        <div className="planname-text-1">
                          Job Opportunity Posting
                        </div>
                        <p>
                          Post your job openings and solicit for qualified
                          candidates
                        </p>
                        <div className="subscription-price-info-1">
                          <div className="plan-price-text-1">
                            ${planType ?? "0"} USD
                          </div>
                          <div className="plan-persave-content-1">
                            <div className="plan-per-text-1">
                              {planType === coupon?.postPriceForOneMonth
                                ? "30"
                                : "90"}{" "}
                              days
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="subscription-point-info-1">
                        <Formik
                          initialValues={initialPaymentValues}
                          onSubmit={makePayment}
                          enableReinitialize
                        >
                          {({ values, setFieldValue }) => (
                            <Form>
                              <div className="cc-planpoint-content">
                                <div className="cc-planpoint-content-inner">
                                  <div className="cc-plan-point-list-1">
                                    <div className="ccradiobox">
                                      <Field
                                        type="radio"
                                        id="Postedjob1"
                                        name="amount"
                                        onChange={(e) => {
                                          setPlanType(
                                            coupon?.postPriceForOneMonth
                                          );
                                          setFieldValue(
                                            "amount",
                                            coupon?.postPriceForOneMonth
                                          );
                                        }}
                                        value={coupon?.postPriceForOneMonth}
                                      />
                                      <label htmlFor="Postedjob1">
                                        ${coupon?.postPriceForOneMonth ?? 0} per
                                        Job Opportunity Posted/month (30 days)
                                      </label>
                                    </div>
                                  </div>
                                  <div className="cc-plan-point-list-1">
                                    <div className="ccradiobox">
                                      <Field
                                        type="radio"
                                        id="Postedjob2"
                                        name="amount"
                                        onChange={(e) => {
                                          setPlanType(
                                            coupon?.postPriceForQuarterly
                                          );
                                          setFieldValue(
                                            "amount",
                                            coupon?.postPriceForQuarterly
                                          );
                                        }}
                                        value={coupon?.postPriceForQuarterly}
                                      />
                                      <label htmlFor="Postedjob2">
                                        ${coupon?.postPriceForQuarterly ?? 0}{" "}
                                        per Job Opportunity Posted/3 months (90
                                        days)
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="plan-action">
                                  <button
                                    type="submit"
                                    className="btn-bl w-100"
                                  >
                                    Make Payment
                                  </button>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                    <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                      {coupon?.isCouponApplied === false &&
                      list?.length !== 0 ? (
                        <div className="text-center mb-2">
                          <span
                            style={{
                              color: "var(--blue)",
                              cursor: "pointer",
                            }}
                            className="text-decoration-underline"
                            onClick={() => setCouponModal(true)}
                          >
                            Have a Coupon Code?
                          </span>
                        </div>
                      ) : null}
                      {coupon?.isCouponApplied === true ? (
                        <div className="w-100">
                          <div class="promo-container mx-auto">
                            <div class="promo-box">
                              <div class="promo-left">
                                <span class="promo-icon">✔️</span>
                                <div>
                                  <p class="promo-code">
                                    Coupon Code:{" "}
                                    <strong>
                                      {coupon?.currentAppliedCoupon
                                        ?.coupon_code ?? ""}
                                    </strong>
                                  </p>
                                </div>
                              </div>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  cancelCoupon(
                                    coupon?.currentAppliedCoupon?.coupon_code ??
                                      ""
                                  );
                                }}
                                class="promo-remove"
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {openCouponModal && (
                        <div className="text-center w-100 d-flex justify-content-center align-items-center">
                          <div className="nwi-input-wrapper">
                            <input
                              type="text"
                              name="text"
                              className="nwi-input"
                              placeholder="Enter Coupon Code"
                              autoComplete="off"
                            />
                            <button
                              onClick={() => {
                                applyCoupon(
                                  document.querySelector(".nwi-input").value
                                );
                              }}
                              className="nwi-Subscribe-btn"
                            >
                              Apply
                            </button>
                          </div>
                          <div className="mx-2">
                            <i
                              onClick={() => {
                                setCouponModal(false);
                              }}
                              style={{
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                              className="fa fa-close"
                            ></i>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default JobPost;
